<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5>
            <p class="table_card__head--title">Editar dispositivo</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                class="breadcums__option"
                @click="$router.push({ name: 'devices' })"
              >
                Listado de dispositivos
              </v-breadcrumbs-item>
              <v-breadcrumbs-item class="breadcums__option" disabled>
                Editar dispositivo
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <button
              type="button"
              class="faccess_button px-5"
              :disabled="formIsInError"
              @click="formIsInError ? '' : updateDevice()"
            >
              Guardar
            </button>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" lazy-validation>
              <v-layout row wrap style="background-color: #fff; padding: 0px;">
                <v-flex xs12 style="padding: 0px 8px 8px 8px;">
                  <p class="table_card__info--label" style="font-size:16px">Información del dispositivo</p>
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label"
                    >Tipo de dispositivo</span
                  >
                  <input
                    v-if="device_info.type != '' && device_info.scan_peripherals.length >= 1"
                    class="faccess_input"
                    type="text"
                    name="name"
                    :value="device_info.type"
                    placeholder="Tipo de dispositivo"
                    disabled
                  />

                  <v-select
                    v-else
                    label="Selecciona un tipo de dispositivo"
                    v-bind:items="deviceTypes"
                    :item-text="'description'"
                    :item-value="'name'"
                    @blur="setActiveErrorField('type')"
                    :style="getFieldStyles('type')"
                    single-line
                    bottom
                    color="#1476FB"
                    v-model="device_info.type"
                    required
                    solo
                    @change="selectDeviceType"
                  ></v-select>

                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label"
                    >Marca de dispositivo</span
                  >
                  <v-select
                    label="Selecciona una marca de dispositivo"
                    v-bind:items="deviceBrands"
                    :item-text="'description'"
                    :item-value="'name'"
                    @blur="setActiveErrorField('brand')"
                    :style="getFieldStyles('brand')"
                    single-line
                    bottom
                    color="#1476FB"
                    v-model="device_info.brand"
                    required
                    solo
                    @change="buildDeviceName"
                  ></v-select>
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label"
                    >Nombre del dispositivo</span
                  >
                  <input
                    class="faccess_input"
                    type="text"
                    name="name"
                    :value="device_info.name"
                    placeholder="Nombre del dispositivo"
                    disabled
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="!['nvr', 'dvr', 'multiple validacion'].includes(device_info.type)"
                >
                  <span class="table_card__info--label">Referencia</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.reference"
                    name="reference"
                    @blur="setActiveErrorField('reference')"
                    :style="getFieldStyles('reference')"
                    placeholder="Referencia"
                    required
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="!['reconocimiento placa', 'multiple validacion'].includes(device_info.type)"
                >
                  <span class="table_card__info--label">UUID</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.uuid"
                    name="uuid"
                    @blur="setActiveErrorField('uuid')"
                    :style="getFieldStyles('uuid')"
                    placeholder="UUID"
                    required
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="!['domo', 'nvr', 'dvr', 'multiple validacion'].includes(device_info.type)"
                >
                  <span class="table_card__info--label"
                    >ID del dispositivo</span
                  >
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.access_device_id"
                    name="access_device_id"
                    @blur="setActiveErrorField('access_device_id')"
                    :style="getFieldStyles('access_device_id')"
                    placeholder="ID del dispositivo"
                    required
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="
                    device_info.type != '' &&
                    device_info.type != 'alarma'
                  "
                >
                  <span class="table_card__info--label"
                    >Proveedor de datos</span
                  >
                  <v-select
                    label="Selecciona un proveedor de datos"
                    v-bind:items="data_providers"
                    :item-text="'name'"
                    :item-value="'name'"
                    single-line
                    @blur="setActiveErrorField('data_provider')"
                    :style="getFieldStyles('data_provider')"
                    bottom
                    color="#1476FB"
                    v-model="device_info.data_provider"
                    required
                    solo
                  ></v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.type == 'reconocimiento facial' &&
                        (device_info.data_provider == 'HikSDK' || device_info.data_provider == 'Gateway-SDK')"
                >
                  <span class="table_card__info--label">IP del dispositivo</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.local_ip"
                    name="local_ip"
                    placeholder="0.0.0.0"
                  />
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label">Locación</span>
                  <v-select
                    label="Selecciona una locación"
                    v-bind:items="locations"
                    :item-text="'name'"
                    :item-value="'id'"
                    single-line
                    @blur="setActiveErrorField('location_id')"
                    :style="getFieldStyles('location_id')"
                    bottom
                    color="#1476FB"
                    v-model="device_info.location_id"
                    solo
                    required
                    @change="selectDeviceLocation"
                  ></v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.type == 'alarma'"
                >
                  <span class="table_card__info--label">Número de abonado</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.account_id"
                    name="account_id"
                    @blur="setActiveErrorField('account_id')"
                    :style="getFieldStyles('account_id')"
                    placeholder="Número de abonado"
                    required
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="
                    device_info.type != '' &&
                      device_info.type != 'alarma'
                  "
                >
                  <span class="table_card__info--label"
                    >Uso del dispositivo</span
                  >
                  <v-select
                    label="Selecciona un tipo de dispositivo"
                    v-bind:items="device_types"
                    :item-text="'text'"
                    :item-value="'name'"
                    single-line
                    @blur="setActiveErrorField('device_type')"
                    :style="getFieldStyles('device_type')"
                    bottom
                    color="#1476FB"
                    v-model="device_info.device_type"
                    required
                    solo
                  ></v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="
                    !['dvr', 'nvr', 'multiple validacion', 'alarma'].includes(device_info.type) &&
                      device_info.device_type == 'Access'
                  "
                >
                  <span class="table_card__info--label"
                    >Dirección de acceso</span
                  >
                  <v-select
                    label="Selecciona una dirección de acceso"
                    v-bind:items="access_directions"
                    :item-text="'text'"
                    :item-value="'name'"
                    single-line
                    @blur="setActiveErrorField('access_direction')"
                    :style="getFieldStyles('access_direction')"
                    bottom
                    color="#1476FB"
                    v-model="device_info.access_direction"
                    required
                    solo
                  ></v-select>
                </v-flex>

                <v-flex
                  v-if="['reconocimiento facial', 'alarma'].includes(device_info.type)"
                  xs6
                  style="padding: 20px 30px 30px 20px"
                >
                  <v-switch
                    class="data_card__switch"
                    :label="`Conexión directa`"
                    color="#1476FB"
                    v-model="device_info.has_direct_connection"
                    required
                  ></v-switch>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.type == 'multiple validacion'"
                >
                  <span class="table_card__info--label">Rango de tiempo</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.time_range"
                    name="time_range"
                    @blur="setActiveErrorField('time_range')"
                    :style="getFieldStyles('time_range')"
                    placeholder="Rango de tiempo"
                    required
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.type == 'multiple validacion'"
                >
                  <span class="table_card__info--label">ID de Puerta</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="device_info.door"
                    name="door"
                    @blur="setActiveErrorField('door')"
                    :style="getFieldStyles('door')"
                    placeholder="ID de Puerta"
                    required
                  />
                </v-flex>
                <v-flex xs12 style="max-width:120%; width:150% !important; margin-top:30px;" v-if="fieldError.length>0" >
                  <p style="color:red;font-size:15px">
                    Complete para continuar: {{fieldError}}
                  </p>
                </v-flex>
              </v-layout>
            </v-form>

            <PeripheralForm
              v-if="peripheral_clone"
              :peripheral="device_info">
            </PeripheralForm>

            <v-form
              onSubmit="return false;"
              ref="form"
              lazy-validation
              v-if="show_peripheral_form"
            >
              <v-layout row wrap style="background-color: #fff; padding: 2rem 0px 0px 0px;">
                <v-flex xs12 style="padding: 0px 8px 8px 8px;">
                  <p class="table_card__info--label" style="font-size:16px">Información del periférico</p>
                </v-flex>
                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label"
                    >Tipo de dispositivo</span
                  >
                  <v-select
                    label="Selecciona un tipo de dispositivo"
                    :items="deviceTypes"
                    :item-text="'description'"
                    :item-value="'name'"
                    @blur="setActiveErrorField('peripheral_type')"
                    :style="getFieldStyles('peripheral_type', true)"
                    single-line
                    color="#1476FB"
                    v-model="peripheral_info.peripheral_type"
                    required
                    solo
                    @change="buildPeripheralName"
                  ></v-select>
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label"
                    >Marca de dispositivo</span
                  >
                  <v-select
                    label="Selecciona una marca de dispositivo"
                    v-bind:items="deviceBrands"
                    :item-text="'name'"
                    :item-value="'name'"
                    @blur="setActiveErrorField('brand')"
                    :style="getFieldStyles('brand', true)"
                    single-line
                    color="#1476FB"
                    v-model="peripheral_info.brand"
                    required
                    solo
                    @change="buildPeripheralName"
                  ></v-select>
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label"
                    >Nombre del dispositivo</span
                  >
                  <input
                    class="faccess_input"
                    type="text"
                    name="name"
                    placeholder="Nombre del dispositivo"
                    :value="peripheral_info.name"
                    disabled
                  />
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label">Referencia</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="peripheral_info.reference"
                    name="reference"
                    @blur="setActiveErrorField('reference')"
                    :style="getFieldStyles('reference', true)"
                    placeholder="Referencia"
                  />
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.type != 'domo'"
                >
                  <span class="table_card__info--label"
                    >ID del dispositivo</span
                  >
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="peripheral_info.access_device_id"
                    name="access_device_id"
                    @blur="setActiveErrorField('access_device_id')"
                    :style="getFieldStyles('access_device_id', true)"
                    placeholder="ID del dispositivo"
                  />
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label">Locación</span>
                  <v-select
                    label="Selecciona una locación"
                    :items="locations"
                    :item-text="'name'"
                    :item-value="'id'"
                    single-line
                    @blur="setActiveErrorField('location_id')"
                    :style="getFieldStyles('location_id', true)"
                    color="#1476FB"
                    v-model="peripheral_info.location_id"
                    solo
                  ></v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.device_type == 'Access'"
                >
                  <span class="table_card__info--label"
                    >Dirección de acceso</span
                  >
                  <v-select
                    label="Selecciona una dirección de acceso"
                    :items="access_directions"
                    :item-text="'text'"
                    :item-value="'name'"
                    single-line
                    @blur="setActiveErrorField('access_direction')"
                    :style="getFieldStyles('access_direction', true)"
                    color="#1476FB"
                    v-model="peripheral_info.access_direction"
                    solo
                  ></v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="device_info.type == 'alarma'"
                >
                  <span class="table_card__info--label">Número de abonado</span>
                  <input
                    class="faccess_input"
                    type="text"
                    v-model="peripheral_info.account_id"
                    name="account_id"
                    @blur="setActiveErrorField('account_id')"
                    :style="getFieldStyles('account_id', true)"
                    placeholder="Número de abonado"
                  />
                </v-flex>

                <v-flex
                  v-if="['reconocimiento facial', 'alarma'].includes(device_info.type)"
                  xs6
                  style="padding: 20px 30px 30px 20px"
                >
                  <v-switch
                    class="data_card__switch"
                    label="Conexión directa"
                    color="#1476FB"
                    v-model="peripheral_info.has_direct_connection"
                    required
                  ></v-switch>
                </v-flex>

                <v-flex xs12 style="max-width:120%; width:150% !important; margin-top:30px;" v-if="peripheralFieldError.length > 0" >
                  <p style="color:red;font-size:15px">
                    Complete para continuar: {{peripheralFieldError}}
                  </p>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          v-if="show_peripheral_form"
          type="button"
          class="faccess_button mr-3"
          @click="peripheralFormError ? '' : associatePeripheral()"
          :disabled="peripheralFormError"
        >
          {{ selected_peripheral !== null ? 'Editar periférico' : 'Asociar periférico' }}
        </button>
        <button
          type="button"
          class="faccess_button px-5"
          :disabled="formIsInError"
          @click="formIsInError ? '' : updateDevice()"
        >
          Guardar
        </button>
      </div>
    </div>

    <div
      class="table_card"
      style="margin: 2rem 0;"
      id="peripheral-form"
      v-if="device_info.type !== '' && !peripheral_clone"
    >
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 row class="filter_options">
            <v-flex xs6>
              <p class="table_card__head--title">Periféricos Asociados</p>
            </v-flex>
            <v-flex class="right mr-0">
              <button
                v-if="!show_peripheral_form"
                class="faccess_button"
                @click="show_peripheral_form = true">
                Crear nuevo periférico
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>

      <v-data-table
        :headers="headers"
        :items="device_info.scan_peripherals"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">
            <a @click="selectPeripheral(props.item)">
              {{ props.item.name }}
            </a>
          </td>
          <td class="text-xs-center">{{ props.item.peripheral_type }}</td>
          <td class="text-xs-center">{{ props.item.access_device_id }}</td>
          <td class="text-xs-center">{{ props.item.reference }}</td>
          <td class="text-xs-center">{{ props.item.brand }}</td>
          <td class="text-xs-center">
            <a @click="show_confirm_modal = true; selected_peripheral = props.item">
              Desvincular
            </a>
          </td>
        </template>
      </v-data-table>
    </div>

    <section
      v-if="show_confirm_modal"
      class="access_devices__modal">
      <section class="access_devices__modal--container" style="width: 40%;">
        <p class="access_devices__modal--text" style="text-align: justify;">
          <b>AVISO:</b> Al desvincular este periférico, todos sus datos serán <b>eliminados</b>.
        </p>
        <br>
        <p class="access_devices__modal--text">
          ¿Está seguro de desvincular este periférico?
        </p>
        <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
          <div
            class="access_devices__modal--button"
            @click="show_confirm_modal = false">
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="removePeripheral">
            Si
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import PeripheralForm from './PeripheralForm.vue';
export default {
  data() {
    return {
      deviceTypes: [],
      deviceBrands: [],
      locations: [],
      device_info: {
        id: "",
        type: "",
        brand: "",
        name: "",
        location_id: "",
        location_name: "",
        has_direct_connection: false,
        access_device_id: "",
        uuid: null,
        local_ip: null,
        reference: "",
        account_id: null,
        device_type: "",
        access_direction: null,
        data_provider: "",
        time_range: null,
        door: null,
        scan_peripheral_id: "",
        scan_peripherals: []
      },
      device_types: [
        { name: "Access", text: "Accesos"},
        { name: "Events", text: "Eventos" }
      ],
      access_directions: [
        { name: "ENTRY", text: "Entrada" },
        { name: "EXIT", text: "Salida" },
        { name: "ACCESS", text: "Accesos" }
      ],
      activeErrorName: true,
      activeErrorField: "",
      fieldError:'',
      peripheralFieldError: "",
      data_providers: [
        "Fuseaccess",
        "Hikcentral",
        "HikSDK",
        "Gateway-SDK"
      ],
      show_peripheral_form: false,
      show_confirm_modal: false,
      selected_peripheral: null,
      peripheral_clone: false,
      headers: [
        { text: "Nombre", sortable: false, value: "name", align: "center" },
        { text: "Tipo", sortable: false, value: "type", align: "center" },
        { text: "ID", sortable: false, value: "access_device_id", align: "center" },
        { text: "Referencia", value: "reference", sortable: false, align: "center" },
        { text: "Marca", value: "brand", sortable: false, align: "center" },
        { text: "Desvincular", value: "disconnect", sortable: false, align: "center"}
      ],
      peripheral_info: {
        id: null,
        name: "",
        peripheral_type: "",
        location_id: "",
        brand: "",
        has_direct_connection: false,
        alarm: false,
        access_device_id: "",
        reference: "",
        access_direction: "",
        account_id: ""
      }
    };
  },

  mounted() {
    this.getLocations();
    this.getPeripheralTypes();
    this.getPeripheralBrands();
  },
  components: {
    PeripheralForm,
  },
  computed: {
    formIsInError() {
      let isError = false;
      let fields=[]

      if (this.device_info.type == "") {
        isError = true;
        fields.push("'Tipo de dispositivo'")
      }

      if (this.device_info.brand == "") {
        isError = true;
        fields.push("'Marca de dispositivo'")
      }

      if (this.device_info.name == "") {
        isError = true;
        fields.push("'Nombre del dispositivo'")
      }

      if (this.device_info.location_id == "") {
        isError = true;
        fields.push("'Locación'")
      }

      if (!['nvr', 'dvr', 'multiple validacion'].includes(this.device_info.type) && this.device_info.reference == "") {
        isError = true;
        fields.push("'Referencia'")
      }

      if (!["domo", "multiple validacion", "dvr", "nvr"].includes(this.device_info.type) && this.device_info.access_device_id == "") {
        isError = true;
        fields.push("'ID del dispositivo'");
      }

      if (
        this.device_info.type == "alarma" &&
        this.device_info.account_id == null
      ) {
        isError = true;
        fields.push("'Número de abonado'")
      }

      if (
        this.device_info.type != "" &&
        this.device_info.type != "alarma"
      ) {
        if (this.device_info.data_provider == "") {
          isError = true;
          fields.push("'Proveedor de datos'")
        }

        if (this.device_info.device_type == "") {
          isError = true;
          fields.push("'Uso del dispositivo'")
        }

        if (!['dvr', 'nvr', 'multiple validacion', 'alarma'].includes(this.device_info.type) &&
            this.device_info.device_type == 'Access' &&
            this.device_info.access_direction == "") {
          isError = true;
          fields.push("'Dirección de acceso'");
        }

        if (this.device_info.type == 'multiple validacion') {
          if (this.device_info.time_range == "") {
            isError = true;
            fields.push("'Rango de tiempo'")
          }
          if (this.device_info.door == "") {
            isError = true;
            fields.push("'ID de puerta'")
          }
        }
      }

      if (!['reconocimiento placa', 'multiple validacion'].includes(this.device_info.type) && this.device_info.uuid == "") {
        isError = true;
        fields.push("'UUID'");
      }

      if(fields.length>0){
        if(fields.length==2){
          this.fieldError=fields.join(" y ")
        }else{
          this.fieldError=fields.join(" , ")
        }
      }else{
        this.fieldError=""
      }

      return isError;
    },

    peripheralFormError() {
      let isError = false;
      let fields = [];

      if (this.peripheral_info.peripheral_type == "") {
        isError = true;
        fields.push("'Tipo de dispositivo'");
      }

      if (this.peripheral_info.brand == "") {
        isError = true;
        fields.push("'Marca de dispositivo'");
      }

      if (this.peripheral_info.location_id == "") {
        isError = true;
        fields.push("'Locación'");
      }

      if (this.peripheral_info.reference == "") {
        isError = true;
        fields.push("'Referencia'");
      }

      if (this.device_info.type != 'domo' && this.peripheral_info.access_device_id == "") {
        isError = true;
        fields.push("'ID del periférico'");
      }

      if (this.device_info.device_type == 'Access' && this.peripheral_info.access_direction == "") {
        isError = true;
        fields.push("'Dirección de acceso'");
      }

      if (this.device_info.type == 'alarma' && this.peripheral_info.account_id == "") {
        isError = true;
        fields.push("'Número de abonado'");
      }

      if (fields.length > 0) {
        if (fields.length == 2) {
          this.peripheralFieldError = fields.join(" y ");
        } else {
          this.peripheralFieldError = fields.join(" , ");
        }
      } else {
        this.peripheralFieldError = "";
      }

      return isError;
    }
  },

  methods: {
    setActiveErrorField(fieldName) {
      console.log("setActiveErrorField->>", fieldName);
      this.activeErrorField = fieldName;
    },

    getFieldStyles(fieldName, isPeripheral) {
      const isErrorActive = this.activeErrorField === fieldName;
      let isFieldEmpty;

      if(isPeripheral){
        isFieldEmpty = this.peripheral_info[fieldName] === "" || this.peripheral_info[fieldName] === null;
      } else {
        isFieldEmpty = this.device_info[fieldName] === "" || this.device_info[fieldName] === null;
      }

      return {
        border: isErrorActive && isFieldEmpty ? "2px solid red" : "",
        "background-color": isErrorActive && isFieldEmpty ? "#ef4b4b15" : ""
      };
    },

    searchPeripheral(id) {
      try {
        this.$http
          .post(
            "scan_peripheral/search_peripheral",
            { data: this.encrypt({ scan_device_id: id }).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(function (response) {
            const deviceInfo = response.body.data.attributes;
            const devicePeripherals = response.body.included ? response.body.included.map(p => p.attributes) : [];
            let firstPeripheralType = '';

            this.device_info.id = deviceInfo.id;
            this.device_info.name = deviceInfo.name;
            this.device_info.uuid = deviceInfo.uuid;
            this.device_info.location_id = deviceInfo.location_id;
            this.device_info.data_provider = deviceInfo.data_provider;
            this.device_info.local_ip = deviceInfo.local_ip;
            this.device_info.time_range = deviceInfo.multiple_validation_time_range;
            this.device_info.door = deviceInfo.multiple_validation_door;
            this.device_info.device_type = deviceInfo.device_type;
            this.peripheral_clone = false;
            this.device_info.location_name = this.locations.filter(loc => loc.id == this.device_info.location_id)[0].name

            if(devicePeripherals.length >= 1){
              this.device_info.scan_peripherals = devicePeripherals.slice();
              this.device_info.type = devicePeripherals[0].peripheral_type;
              this.device_info.brand = devicePeripherals[0].brand;

              console.log(devicePeripherals)
              console.log(this.device_info.type)
              firstPeripheralType = this.device_info.scan_peripherals[0].peripheral_type;
              this.device_info.type = this.device_info.time_range != null || this.device_info.door != null ? 'multiple validacion' :
                                      this.device_info.name.toLowerCase().includes('dvr') && firstPeripheralType  === 'camara' ? 'dvr' :
                                      this.device_info.name.toLowerCase().includes('nvr') && firstPeripheralType === 'camara' ? 'nvr' :
                                      firstPeripheralType
              console.log(this.device_info.type)

              if (this.device_info.scan_peripherals.length == 1 && !['dvr', 'nvr', 'camara', 'multiple validacion'].includes(this.device_info.type)) {
                this.peripheral_clone = true;
                this.device_info.reference = devicePeripherals[0].reference;
                this.device_info.has_direct_connection = devicePeripherals[0].has_direct_connection;
                this.device_info.access_device_id = devicePeripherals[0].access_device_id;
                this.device_info.access_direction = devicePeripherals[0].access_direction;
                this.device_info.account_id = devicePeripherals[0].account_id;
              }
            }



            console.log("this.device_info -->", this.device_info);
          });
      } catch (e) {
        alert(e.message);
      }
    },

    getLocations() {
      try {
        this.$http
          .get("scan_peripheral/get_locations", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          })
          .then(function(response) {
            this.locations = response.body.data;
            this.searchPeripheral(this.$route.params.id);
            console.log("device types ", response.body.data);
          });
      } catch (e) {
        alert(e.message);
      }
    },

    getPeripheralTypes() {
      try {
        this.$http
          .get("scan_peripheral/get_peripheral_types", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          })
          .then(function(response) {
            this.deviceTypes = response.body.data;
            console.log("device types ", response.body.data);
          });
      } catch (e) {
        alert(e.message);
      }
    },

    getPeripheralBrands() {
      try {
        this.$http
          .get("scan_peripheral/get_peripheral_brands", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          })
          .then(function(response) {
            this.deviceBrands = response.body.data;
            console.log("device brands ", response.body.data);
          });
      } catch (e) {
        alert(e.message);
      }
    },

    selectDeviceType(){
      this.peripheral_clone = !['dvr', 'nvr', 'multiple validacion'].includes(this.device_info.type);
      if(this.show_peripheral_form && this.peripheral_clone) this.show_peripheral_form = false;
      this.buildDeviceName();
    },

    selectDeviceLocation(){
      this.device_info.location_name = this.locations.filter(loc => loc.id == this.device_info.location_id)[0].name
    },

    buildDeviceName(){
      if(this.device_info.type != '' && this.device_info.brand != ''){
        this.device_info.name = `${this.device_info.type} - ${this.device_info.brand}`;
      }
    },

    buildPeripheralName(){
      if(this.peripheral_info.peripheral_type != '' && this.peripheral_info.brand != ''){
        this.peripheral_info.name = `${this.peripheral_info.peripheral_type} - ${this.peripheral_info.brand}`;
      }
    },

    selectPeripheral(peripheral){
      this.peripheral_info.id = peripheral.id;
      this.peripheral_info.name = peripheral.name;
      this.peripheral_info.peripheral_type = peripheral.peripheral_type;
      this.peripheral_info.location_id = peripheral.location_id;
      this.peripheral_info.brand = peripheral.brand;
      this.peripheral_info.has_direct_connection = peripheral.has_direct_connection;
      this.peripheral_info.alarm = peripheral.alarm;
      this.peripheral_info.access_device_id = peripheral.access_device_id;
      this.peripheral_info.reference = peripheral.reference;
      this.peripheral_info.access_direction = peripheral.access_direction;
      this.selected_peripheral = this.device_info.scan_peripherals.indexOf(peripheral);
      this.show_peripheral_form = true;
    },

    associatePeripheral(){
      const newPeripheral = {
        id: this.peripheral_info.id,
        name: this.peripheral_info.name,
        peripheral_type: this.peripheral_info.peripheral_type,
        location_id: this.peripheral_info.location_id,
        access_device_id: this.peripheral_info.access_device_id,
        brand: this.peripheral_info.brand,
        has_direct_connection: this.peripheral_info.has_direct_connection,
        alarm: this.peripheral_info.alarm,
        reference: this.peripheral_info.reference,
        access_direction: this.peripheral_info.access_direction
      }
      this.show_peripheral_form = false;

      if(this.selected_peripheral !== null){
        const newPeripherals = this.device_info.scan_peripherals.slice();
        newPeripherals[this.selected_peripheral] = newPeripheral;
        this.device_info.scan_peripherals = newPeripherals;
      }
      else this.device_info.scan_peripherals.push(newPeripheral);

      console.log(this.device_info.scan_peripherals)
      this.clearPeripheralForm();
    },

    removePeripheral(){
      this.show_confirm_modal = false;
      if(this.selected_peripheral.id){
        try {
          this.$http
            .post(
              "scan_peripheral/disconnect_peripheral_from_device",
              {
                data: this.encrypt({scan_peripheral_id: this.selected_peripheral.id}).toString()
              },
              {
                headers: {
                  "X-Device-ID": this.getDeviceId(),
                  Authorization: "Bearer " + this.getUserToken()
                }
              }
            )
            .then(
              function(response) {
                const selectedPeripheralIndex = this.device_info.scan_peripherals.indexOf(this.selected_peripheral);
                this.device_info.scan_peripherals.splice(selectedPeripheralIndex, 1);
                this.show_peripheral_form = false;
                this.clearPeripheralForm();
                this.updateAlertMessage(response.body.ans);
                this.updateIsInAlert(true);
                if (
                  response.body.meta != undefined &&
                  response.body.meta != null
                ) {
                  if (
                    response.body.meta.authentication_token != undefined &&
                    response.body.meta.authentication_token != null
                  ) {
                    this.checkToken(response.body.meta.authentication_token);
                  }
                }
              }
            );
        } catch (e) {
          if (response.body.meta != undefined && response.body.meta != null) {
            if (
              response.body.meta.authentication_token != undefined &&
              response.body.meta.authentication_token != null
            ) {
              this.checkToken(response.body.meta.authentication_token);
            }
          }
          alert(e.message);
        }

      } else {
        const selected_peripheral = this.device_info.scan_peripherals.indexOf(this.selected_peripheral);
        this.device_info.scan_peripherals.splice(selected_peripheral, 1);
      }
    },

    updateDevice() {
      if(this.peripheral_clone) this.loadPeripheralsInfo();
      const data = { device_info: this.device_info };
      try {
        this.$http
          .put(
            "scan_peripheral/update_peripheral",
            {
              data: this.encrypt(data).toString()
            },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(
            function(response) {
              this.updateAlertMessage(response.body.ans);
              this.updateIsInAlert(true);
              this.$router.push({ name: "devices" });
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function(response) {
              this.updateAlertMessage(response.body.ans);
              this.updateIsInAlert(true);
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            }
          );
      } catch (e) {
        if (response.body.meta != undefined && response.body.meta != null) {
          if (
            response.body.meta.authentication_token != undefined &&
            response.body.meta.authentication_token != null
          ) {
            this.checkToken(response.body.meta.authentication_token);
          }
        }
        alert(e.message);
      }
    },

    loadPeripheralsInfo() {
      if (this.device_info.scan_peripherals.length == 0){
        this.device_info.scan_peripherals = [
          {
            name: this.device_info.name,
            peripheral_type: this.device_info.type,
            location_id: this.device_info.location_id,
            brand: this.device_info.brand,
            access_device_id: this.device_info.type === "domo" ? this.device_info.name : this.device_info.access_device_id,
            has_direct_connection: this.device_info.has_direct_connection,
            reference: this.device_info.reference,
            account_id: this.device_info.account_id,
            alarm: this.device_info.type === 'alarma',
            access_direction: this.device_info.access_direction
          }
        ];

      } else {
        this.device_info.scan_peripherals[0].name = this.device_info.name;
        this.device_info.scan_peripherals[0].peripheral_type = this.device_info.type;
        this.device_info.scan_peripherals[0].location_id = this.device_info.location_id;
        this.device_info.scan_peripherals[0].brand = this.device_info.brand;
        this.device_info.scan_peripherals[0].access_device_id = this.device_info.type === "domo" ? this.device_info.name : this.device_info.access_device_id;
        this.device_info.scan_peripherals[0].has_direct_connection = this.device_info.has_direct_connection;
        this.device_info.scan_peripherals[0].reference = this.device_info.reference;
        this.device_info.scan_peripherals[0].account_id = this.device_info.account_id;
        this.device_info.scan_peripherals[0].alarm = this.device_info.type === 'alarma';
        this.device_info.scan_peripherals[0].access_direction = this.device_info.access_direction;
      }
    },

    updatePeripheral(peripheral){
      this.device_info.scan_peripherals[this.selected_peripheral].access_device_id = peripheral.access_device_id;
      this.device_info.scan_peripherals[this.selected_peripheral].name = peripheral.name;
      this.device_info.scan_peripherals[this.selected_peripheral].peripheral_type = peripheral.peripheral_type;
      this.device_info.scan_peripherals[this.selected_peripheral].reference = peripheral.reference;
    },

    clearPeripheralForm(){
      this.peripheral_info.id = null;
      this.peripheral_info.name = "";
      this.peripheral_info.peripheral_type = "";
      this.peripheral_info.location_id = "";
      this.peripheral_info.brand = "";
      this.peripheral_info.has_direct_connection = false;
      this.peripheral_info.alarm = false;
      this.peripheral_info.access_device_id = "";
      this.peripheral_info.reference = "";
      this.peripheral_info.access_direction = "";
      this.selected_peripheral = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/devices/Edit_Device.vue